import { search_children } from "dependencies/simpleSearch/index.js"

export default {
  name: "列表页搜索",
  id: "",
  type: "cxSimpleSearchState",
  componentType: "emptyLayoutComponent",
  children: search_children,
  enable(params) {
    let homePageBusinessFlag = true
    let detailPageBusinessFlag = true
    if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
      homePageBusinessFlag = false
    }
    if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
      detailPageBusinessFlag = false
    }
    return params.admin && homePageBusinessFlag && detailPageBusinessFlag
  },
}
